import { Button } from "@do/ui/components/button";
import { cn } from "@do/ui/lib/utils";
import { ArrowUpIcon } from "lucide-react";
import { useTranslations } from "next-intl";

export const FooterInputSendButton = ({ disabled }: { disabled?: boolean }) => {
  const t = useTranslations("do-chat-v2");

  return (
    <Button
      id="footer-input-send-button"
      aria-label={t("chat.footer.accessibility.send-message-aria-label")}
      data-test="send"
      disabled={disabled}
      type="submit"
      size="icon"
      className={cn(
        "absolute z-1 group/footer-input-send-button",
        "right-(--footer-input-actions-button-offset)",
        "bottom-(--footer-input-actions-button-offset)",
        "size-(--footer-input-actions-button-size)",
        "rounded-(--footer-input-actions-button-border-radius)",
        "bg-(--footer-input-send-button-background)/(--footer-input-send-button-background-opacity)",
        "hover:bg-(--footer-input-send-button-hover-background)/(--footer-input-send-button-hover-background-opacity)",
        "border-(length:--footer-input-send-button-border-width)",
        "border-(--footer-input-send-button-border-color)/(--footer-input-send-button-border-opacity)",
        "hover:border-(--footer-input-send-button-hover-border-color)/(--footer-input-send-button-hover-border-opacity)",
        "[box-shadow:var(--footer-input-send-button-box-shadow)]"
      )}
    >
      <ArrowUpIcon
        id="footer-input-send-button-icon"
        aria-hidden="true"
        className={cn(
          "size-(--footer-input-send-button-icon-size)",
          "text-(--footer-input-send-button-foreground)/(--footer-input-send-button-foreground-opacity)",
          "group-hover/footer-input-send-button:text-(--footer-input-send-button-hover-foreground)/(--footer-input-send-button-hover-foreground-opacity)"
        )}
      />
    </Button>
  );
};
